import React, { FC } from 'react'
import { breakpointDown, styled } from '@moonpig/launchpad-utils'
import { Box } from '@moonpig/launchpad-components'

const StyledLineContainer = styled(Box)`
  position: relative;
  width: 100%;
  height: 65px;
  overflow: hidden;

  ${breakpointDown('md')} {
    display: none;
  }
`

const StyledCurveLine = styled(Box)`
  position: absolute;
  bottom: -150px;
  height: 150px;
  width: 100%;
  border-radius: 50%;
  transform: scale(1.2, 1.8);
`

export const CurveLine: FC<{ bgcolor: string }> = ({ bgcolor }) => (
  <StyledLineContainer data-testid="mp-find-curve-line-module">
    <StyledCurveLine bgcolor={bgcolor} />
  </StyledLineContainer>
)
